import React from 'react';
import ResultSuccess from './result-success';
import ResultFailure from './result-failure';
import { useState } from 'react';
import { FlexView } from '@cuemath/comps';
import LAYOUT from 'constants/layout';

const { GAP, GUTTER } = LAYOUT;

const MapperMappingResult = result => {
  const { mappingSearchResult, dateTimePreset, filters, prospectId } = result ?? {};
  const { teachers } = mappingSearchResult ?? {};
  const [showOtherTeachers, setShowOtherTeachers] = useState(false);
  const failedSearch = teachers.length === 0;
  return failedSearch ? (
    <FlexView gutter={GUTTER} gap={GAP}>
      <ResultFailure />
    </FlexView>
  ) : (
    <FlexView gutter={GUTTER} gap={GAP}>
      <ResultSuccess
        mappingSearchResult={mappingSearchResult}
        showOtherTeachers={showOtherTeachers}
        setShowOtherTeachers={setShowOtherTeachers}
        dateTimePreset={dateTimePreset}
        filters={filters}
        prospectId={prospectId}
      />
    </FlexView>
  );
};

export default MapperMappingResult;
